import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import QuickLinks from "./components/QuickLinks";
import MissionSection from "./components/MissionSection";
import Footer from "./components/Footer";
import SummaryPlanSection from "./components/SummaryPlanSection";
import PlanRulesSection from "./components/PlanRulesSection";
import MemberPortalSection from "./components/MemberPortalSection";

export default function Home() {
  const location = useLocation();

  // Handle hash-based scrolling when arriving from another page.
  // The Navbar navigates to /#hash from other pages; we listen for the hash
  // and scroll once the DOM is committed. Same-page hash clicks are handled
  // directly in the Navbar via smooth-scroll, so we only act on mount here.
  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace("#", "");
    // Home link should never scroll to the hero anchor — Navbar handles it
    if (id === "home") return;

    const scrollToSection = () => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 56;
        window.scrollTo({ top, behavior: "smooth" });
      }
    };

    // Double rAF ensures the DOM is fully painted before we measure positions
    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToSection);
    });
  }, [location.hash]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <QuickLinks />
        <MissionSection />
        <SummaryPlanSection />
        <PlanRulesSection />
        <MemberPortalSection />
      </main>
      <Footer />
    </div>
  );
}